import { ApiMethod } from 'services/api';
import { useRestMutation } from 'utils/hooks/api/useRestMutation';

export const CANCEL_CAMPAIGN_URL = '/email/cancelScheduledCampaign';

export const useCancelCampaignMutation = () => {
  const { isLoading, mutate, error } = useRestMutation(CANCEL_CAMPAIGN_URL, ApiMethod.post);
  return { isLoading, mutate, error };
};
